import React from "react";

const Button = (props) => {
  let buttonText;
  if (props.isAdding) {
    buttonText = "Saving...";
  } else {
    buttonText = props.children || props.text;
  }
  return (
    <button
      {...props}
      onClick={props.onClick}
      disabled={props.isAdding || props.isDisabled || false}
      style={{
        color: props?.color,
        fontSize: props?.fSize,
        padding: props?.padding,
      }}
    >
      {buttonText}
    </button>
  );
};

export default Button;
